module.exports = __webpack_public_path__ + "img/maintenance.8bf40d29.png";